'use strict';

var _ = require('lodash');
var ActionItem = require('actions/shared/ActionItem');
var i18n = require('i18next');

/**
 * Edit model for Bond Description
 */
module.exports = ActionItem.extend({
  /**
   * @member {Object} actions/description/bond/EditDescription#attributes
   * @property {string} description
   *   Bond description
   */

  _snapshotAttributes: ['description'],

  /**
   * @return {Boolean}
   */
  isNew: function() {
    var bond = this.deviceConfig.get('nicBonds').get(this.id);
    return _.isUndefined(bond) || bond.isNew();
  },

  /**
   * @param {Object} resp
   * @param {Object} options
   * @return {Object}
   */
  parse: function(resp, options) {
    if (options && options.fromConfig && !this.isNew()) {
      return {description: this.getDescriptionFromConfig(this.id)};
    }

    return resp;
  },

  reparseConfigTriggers: [
    {
      getDispatcher: function(config) {
        return config.get('nicBonds').get(this.id);
      },
      events: 'change:description',
    },
  ],

  /**
   * @param {Object} attrs
   * @param {Object} options
   * @return {Object|undefined}
   */
  validate: function(attrs, options) {
    var errors = {};
    var validateAll = (options && options.validateAll !== false);

    if (!_.isUndefined(attrs.description) || validateAll) {
      if (_.isEmpty(attrs.description)) {
        errors.description = i18n.t('bondDescription.badDescription');
      }

      if (!errors.description && !this._validDescription(attrs.description)) {
        errors.description = i18n.t('bondDescription.duplicateDescription');
      }
    }

    if (_.size(errors) > 0) {
      return errors;
    }
  },

  /**
   * @param {String} id
   *   The bonds's ID (e.g. bondX)
   * @return {String}
   */
  getDescriptionFromConfig: function(id) {
    var config = this.deviceConfig;
    var nicBonds = config.get('nicBonds');
    var nicBond = nicBonds.get(id);

    return nicBond.get('description');
  },

  /**
   * @return {Object}
   */
  getTask: function() {
    var data = {description: this.get('description')};

    if (!this.isNew()) {
      data.id = this.id;
    }

    return {
      name: 'nicBond.create',
      data: data,
    };
  },

  /**
   * Verify that the entered description is not the same as other port aggregates.
   *
   * @private
   * @param {String} description
   * @returns {Boolean}
   */
  _validDescription: function(description) {
    var self = this;
    // No duplicate descriptions
    var duplicates = this.deviceConfig.get('nicBonds').filter(function(nicBond) {
      return (nicBond.get('description').toLowerCase().trim() === description.toLowerCase().trim() &&
        nicBond.id !== self.id);
    });

    return _.isEmpty(duplicates);
  },
});
